import styles from "./Home.module.css";

const Home = () => {
  return (
    <section className={`${styles.home} section`} id="home">
      <div>
        <p>
          Oi <span>&#x1F44B;</span> eu sou o Guilherme
        </p>
        <h1>
          Front end
          <br />
          Developer
        </h1>
        <div className={`${styles.about_me} grid`}>
          <p>
            Tenho 23 anos, atuo como desenvolvedor Front End especializando-me
            em <span>React JS, JavaScript, HTML</span> e <span>CSS</span>.
          </p>
          <div>
            <a
              href="https://github.com/Siqueira2"
              target="_blank"
              rel="noreferrer"
            >
              <i className="uil uil-github-alt"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/guilherme-siqueira-98aa54254"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa-brands fa-linkedin-in"></i>
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=5531975263254&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noreferrer"
            >
              <i className="uil uil-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
